module.exports = __webpack_public_path__ + "img/9.da3940dc.png";